export class Base64ToBinary {

    keyStr: string = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

    /* will return a  Uint8Array type */
    // decodeArrayBuffer(input) {
    //     const bytes = (input.length / 4) * 3;
    //     const ab = new ArrayBuffer(bytes);
    //     this.decode(input, ab);

    //     return ab;
    // }
    decodeArrayBuffer(base64: string): ArrayBuffer {
        const binaryString = atob(base64); // Decode Base64 to binary string
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i); // Convert to byte array
        }
        return bytes.buffer;
    }

    removePaddingChars(input) {
        const lkey = this.keyStr.indexOf(input.charAt(input.length - 1));
        if (lkey === 64) {
            return input.substring(0, input.length - 1);
        }
        return input;
    }

    decode(input, arrayBuffer) {
        // get last chars to see if are valid
        input = this.removePaddingChars(input);
        input = this.removePaddingChars(input);

        const bytes = parseInt(((input.length / 4) * 3).toString(), 10);

        let uarray;
        // tslint:disable-next-line: one-variable-per-declaration
        let chr1, chr2, chr3;
        // tslint:disable-next-line: one-variable-per-declaration
        let enc1, enc2, enc3, enc4;
        let i = 0;
        let j = 0;

        if (arrayBuffer) {
            uarray = new Uint8Array(arrayBuffer);
        } else {
            uarray = new Uint8Array(bytes);
        }

        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

        for (i = 0; i < bytes; i += 3) {
            // get the 3 octects in 4 ascii chars
            enc1 = this.keyStr.indexOf(input.charAt(j++));
            enc2 = this.keyStr.indexOf(input.charAt(j++));
            enc3 = this.keyStr.indexOf(input.charAt(j++));
            enc4 = this.keyStr.indexOf(input.charAt(j++));

            // tslint:disable-next-line: no-bitwise
            chr1 = (enc1 << 2) | (enc2 >> 4);
            // tslint:disable-next-line: no-bitwise
            chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
            // tslint:disable-next-line: no-bitwise
            chr3 = ((enc3 & 3) << 6) | enc4;

            uarray[i] = chr1;
            if (enc3 !== 64) {
                uarray[i + 1] = chr2;
            }

            if (enc4 !== 64) {
                uarray[i + 2] = chr3;
            }
        }

        return uarray;
    }
}
